import { imageNames } from "@/src/constants/imageConstants.js";

const sequenceStepTypes = {
  PHONE_CALL: "PHONE_CALL",
  TASK: "TASK",
  EMAIL: "EMAIL",
  VOICE: "VOICE",
  QUALIFICATION: "QUALIFICATION",
  MARKET_RESEARCH: "MARKET_RESEARCH",
  NEXT_BEST_ACTION: "NEXT_BEST_ACTION",
  MULTI_THREADING: "MULTI_THREADING",
  LINKEDIN_MESSAGE: "LINKEDIN_MESSAGE",
  LINKEDIN_INVITE: "LINKEDIN_INVITE",
  LINKEDIN_INMAIL: "LINKEDIN_INMAIL",
  WHATSAPP_MESSAGE: "WHATSAPP_MESSAGE",
};

const sequenceAutomationTypes = {
  AUTOMATED: "AUTOMATED",
  TASK: "TASK",
  AI: "AI",
};

const generateStepId = (automationType, stepType) => {
  const mapping = {
    [`${sequenceAutomationTypes.AI}_${sequenceStepTypes.EMAIL}`]:
      "ai_email_agent",
    [`${sequenceAutomationTypes.AI}_${sequenceStepTypes.QUALIFICATION}`]:
      "qualification_agent",
    [`${sequenceAutomationTypes.AI}_${sequenceStepTypes.MARKET_RESEARCH}`]:
      "market_research_agent",
    [`${sequenceAutomationTypes.AI}_${sequenceStepTypes.MULTI_THREADING}`]:
      "multi_threading_agent",
    [`${sequenceAutomationTypes.AI}_${sequenceStepTypes.NEXT_BEST_ACTION}`]:
      "next_best_action",
    [`${sequenceAutomationTypes.AI}_${sequenceStepTypes.LINKEDIN_MESSAGE}`]:
      "ai_linkedin_message_agent",
    [`${sequenceAutomationTypes.AI}_${sequenceStepTypes.LINKEDIN_INMAIL}`]:
      "ai_linkedin_inmail_agent",
    [`${sequenceAutomationTypes.AUTOMATED}_${sequenceStepTypes.EMAIL}`]:
      "automatic_email",
    [`${sequenceAutomationTypes.AUTOMATED}_${sequenceStepTypes.LINKEDIN_MESSAGE}`]:
      "linkedin_message",
    [`${sequenceAutomationTypes.AUTOMATED}_${sequenceStepTypes.LINKEDIN_INMAIL}`]:
      "linkedin_inmail",
    [`${sequenceAutomationTypes.AUTOMATED}_${sequenceStepTypes.LINKEDIN_INVITE}`]:
      "linkedin_connection_request",
    [`${sequenceAutomationTypes.TASK}_${sequenceStepTypes.TASK}`]: "task",
    [`${sequenceAutomationTypes.TASK}_${sequenceStepTypes.EMAIL}`]:
      "manual_email",
    [`${sequenceAutomationTypes.TASK}_${sequenceStepTypes.PHONE_CALL}`]:
      "phone_call",
    [`${sequenceAutomationTypes.TASK}_${sequenceStepTypes.LINKEDIN_MESSAGE}`]:
      "linkedin_message_task",
    [`${sequenceAutomationTypes.TASK}_${sequenceStepTypes.LINKEDIN_INMAIL}`]:
      "linkedin_inmail_task",
    [`${sequenceAutomationTypes.TASK}_${sequenceStepTypes.LINKEDIN_INVITE}`]:
      "linkedin_connection_request_task",
    [`${sequenceAutomationTypes.AUTOMATED}_${sequenceStepTypes.WHATSAPP_MESSAGE}`]:
      "whatsapp_message",
    [`${sequenceAutomationTypes.TASK}_${sequenceStepTypes.WHATSAPP_MESSAGE}`]:
      "whatsapp_message_task",
  };
  return mapping[`${automationType}_${stepType}`];
};

export const stepOptions = {
  ai: {
    title: "Agents",
    options: [
      {
        title: "AI Email Agent",
        description:
          "Automatically creates and send AI-personalized emails to prospects.",
        icon: imageNames.EMAIL_GREY,
        stepType: sequenceStepTypes.EMAIL,
        automationType: sequenceAutomationTypes.AI,
      },
      {
        title: "Qualification Agent",
        description:
          "Assesses and qualifies leads based on predefined criteria.",
        icon: imageNames.QUALIFICATION_GREY,
        stepType: sequenceStepTypes.QUALIFICATION,
        automationType: sequenceAutomationTypes.AI,
      },
      {
        title: "Market Research Agent",
        description:
          "Conducts Market Research on Prospect for personalized outreach.",
        icon: imageNames.MARKET_RESEARCH_GREY,
        stepType: sequenceStepTypes.MARKET_RESEARCH,
        automationType: sequenceAutomationTypes.AI,
      },
      {
        title: "Multi Threading Agent",
        description:
          "Automatically engage multiple stakeholders within a single company.",
        icon: imageNames.MULTI_THREADING_GREY,
        stepType: sequenceStepTypes.MULTI_THREADING,
        automationType: sequenceAutomationTypes.AI,
      },
      {
        title: "Next Best Action",
        description:
          "Recommends the most effective follow-up action for each prospect.",
        icon: imageNames.NEXT_BEST_ACTION_GREY,
        stepType: sequenceStepTypes.NEXT_BEST_ACTION,
        automationType: sequenceAutomationTypes.AI,
      },
      {
        title: "AI LinkedIn - Message Agent",
        description:
          "Automatically creates and sends AI-personalized LinkedIn messages.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_MESSAGE,
        automationType: sequenceAutomationTypes.AI,
      },
      {
        title: "AI LinkedIn - InMail Agent",
        description:
          "Automatically creates and sends AI-personalized LinkedIn InMails.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_INMAIL,
        automationType: sequenceAutomationTypes.AI,
      },
    ],
  },
  automated: {
    title: "Automatic",
    options: [
      {
        title: "Automatic Email",
        description:
          "Emails are delivered automatically without manual effort.",
        icon: imageNames.AUTOMATIC_EMAIL_GREY,
        stepType: sequenceStepTypes.EMAIL,
        automationType: sequenceAutomationTypes.AUTOMATED,
      },
      {
        title: "Automatic LinkedIn - Message",
        description: "Send LinkedIn Messages automatically.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_MESSAGE,
        automationType: sequenceAutomationTypes.AUTOMATED,
      },
      {
        title: "Automatic LinkedIn - InMail",
        description: "Send LinkedIn InMails automatically.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_INMAIL,
        automationType: sequenceAutomationTypes.AUTOMATED,
      },
      {
        title: "Automatic LinkedIn - Connection Request",
        description:
          "Send LinkedIn connection requests with or without note automatically.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_INVITE,
        automationType: sequenceAutomationTypes.AUTOMATED,
      },
      {
        title: "Automatic WhatsApp Message",
        description: "Send WhatsApp messages automatically.",
        icon: imageNames.WHATSAPP_GREY,
        stepType: sequenceStepTypes.WHATSAPP_MESSAGE,
        automationType: sequenceAutomationTypes.AUTOMATED,
      },
    ],
  },
  manual: {
    title: "Manual",
    options: [
      {
        title: "Task",
        description:
          "description will be displayed here description will be here",
        icon: imageNames.NEW_TASK_GREY,
        stepType: sequenceStepTypes.TASK,
        automationType: sequenceAutomationTypes.TASK,
      },
      {
        title: "Manual Email Task",
        description: "Task is created to create and send emails.",
        icon: imageNames.EMAIL_GREY,
        stepType: sequenceStepTypes.EMAIL,
        automationType: sequenceAutomationTypes.TASK,
      },
      {
        title: "Manual Phone Call Task",
        description: "Create a task to make a phone call.",
        icon: imageNames.CALL_GREY,
        stepType: sequenceStepTypes.PHONE_CALL,
        automationType: sequenceAutomationTypes.TASK,
      },
      {
        title: "Manual LinkedIn - Message Task",
        description:
          "Task is created to send a LinkedIn message to a prospect.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_MESSAGE,
        automationType: sequenceAutomationTypes.TASK,
      },
      {
        title: "Manual LinkedIn - InMail Task",
        description: "Task is created to send a LinkedIn InMail to a prospect.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_INMAIL,
        automationType: sequenceAutomationTypes.TASK,
      },
      {
        title: "Manual LinkedIn - Connection Request Task",
        description:
          "Task is created to send a LinkedIn Connection Request to a prospect.",
        icon: imageNames.LINKEDIN,
        stepType: sequenceStepTypes.LINKEDIN_INVITE,
        automationType: sequenceAutomationTypes.TASK,
      },
      {
        title: "Manual WhatsApp Message Task",
        description: "Task is created to send a WhatsApp message to a prospect.",
        icon: imageNames.WHATSAPP_GREY,
        stepType: sequenceStepTypes.WHATSAPP_MESSAGE,
        automationType: sequenceAutomationTypes.TASK,
      },
    ],
  },
};

export { generateStepId };
export {sequenceAutomationTypes};
export {sequenceStepTypes};
